import { Truemed } from 'ui/icons/icons/Growth/Truemed';
import { HsaFsaCheck } from 'ui/icons/icons/Growth/HsaFsaCheck';
import { useTranslation } from '@whoop/i18n/lang/client';
import { EXPERIMENT_JF_HSA_FSA_MESSAGING, HSA_FSA_PLAN_CARDS_VARIANT, HSA_FSA_TAGS_VARIANT } from '@/lib/constants/experiments';
import { clsx } from 'clsx';
import { useShallow } from 'zustand/react/shallow';
import { useSiteStore } from '@/store/SiteStoreProvider';
const HsaFsaCardBadge = ({
  isOnPlanCard
}: {
  isOnPlanCard?: boolean;
}) => {
  const {
    t
  } = useTranslation('fsaHsa');
  return <div className='flex items-center justify-center gap-x-1 whitespace-nowrap' data-testid='hsa-fsa-card-badge' data-sentry-component="HsaFsaCardBadge" data-sentry-source-file="TruemedHsaFsaBadge.tsx">
      <HsaFsaCheck data-sentry-element="HsaFsaCheck" data-sentry-source-file="TruemedHsaFsaBadge.tsx" />
      <span className='font-regular text-sm text-black'>{t('payWith')}</span>
      <div className={clsx('flex items-center text-sm text-black', isOnPlanCard ? 'font-regular' : 'font-bold')}>
        HSA/FSA
      </div>
      <span className='font-regular text-sm text-black'>{t('card')}</span>
    </div>;
};
export const TruemedBadge = () => {
  const {
    t
  } = useTranslation('hsaFsa');
  return <div className='flex items-center justify-center gap-x-1 whitespace-nowrap' data-testid='truemed-badge' data-sentry-component="TruemedBadge" data-sentry-source-file="TruemedHsaFsaBadge.tsx">
      <div className='flex items-center text-sm font-bold text-black'>
        <HsaFsaCheck data-sentry-element="HsaFsaCheck" data-sentry-source-file="TruemedHsaFsaBadge.tsx" /> HSA/FSA
      </div>
      <span className='font-regular text-sm text-black'>
        {t('eligibleWith')}
      </span>
      <Truemed data-sentry-element="Truemed" data-sentry-source-file="TruemedHsaFsaBadge.tsx" />
    </div>;
};
export function TruemedHsaFsaBadge({
  isOnPlanCard
}: {
  isOnPlanCard?: boolean;
}) {
  const {
    experimentVariants,
    asAGift
  } = useSiteStore(useShallow(state => ({
    experimentVariants: state.experimentVariants,
    asAGift: state.asAGift
  })));
  const hsaFsaMessagingVariant = experimentVariants[EXPERIMENT_JF_HSA_FSA_MESSAGING] || '';
  const isHsaFsaMessagingVariant = [HSA_FSA_PLAN_CARDS_VARIANT, HSA_FSA_TAGS_VARIANT].includes(hsaFsaMessagingVariant);
  if (asAGift) return null;
  return <div className='flex items-center justify-center gap-x-1 whitespace-nowrap' data-testid='truemed-hsa-fsa-badge' data-sentry-component="TruemedHsaFsaBadge" data-sentry-source-file="TruemedHsaFsaBadge.tsx">
      {isHsaFsaMessagingVariant ? <HsaFsaCardBadge isOnPlanCard={isOnPlanCard} /> : <TruemedBadge />}
    </div>;
}